import styled, { css } from 'styled-components'
import { mq } from '../../../styles/vars/media-queries.style'
import { clamp } from '../../../styles/utils/conversion.style'
import { breakpoints } from '../../../styles/vars/breakpoints.style'
import { easings } from '../../../styles/vars/easings.style'
import { colors } from '../../../styles/vars/colors.style'

export const FormSelectLine = styled.label`
  background-color: ${colors.darkBlue};
  bottom: 0;
  height: 0.1rem;
  left: 0;
  position: absolute;
  right: 0;
  transform-origin: 0% 0%;
`

export const FormSelectLabel = styled.label`
  cursor: pointer;
  display: block;
  line-height: 1;
  pointer-events: all;
`

const formSelectShared = css`
  line-height: 1.2;
  padding-bottom: 2rem;
  ${clamp('padding-top', 40, 30, breakpoints.mobile, breakpoints.contained)};
  width: 100%;
`

export const FormSelectElement = styled.select`
  ${formSelectShared}
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  pointer-events: all;
`

export const FormSelectName = styled.span`
  ${formSelectShared}
  bottom: 0;
  left: 0;
  right: 0;
  display: block;
  opacity: 0.4;
  position: absolute;
  pointer-events: none;
  text-transform: uppercase;
  transition: transform 0.7s ${easings.inOut.quart};
  transform: translateY(${props => (props.focused ? `-3rem` : `0`)});
  user-select: none;

  ${mq.tabletL} {
    transform: translateY(${props => (props.focused ? `-4rem` : `0`)});
  }

  ${FormSelectElement}:focus + & {
    transform: translateY(-3rem);

    ${mq.tabletL} {
      transform: translateY(-4rem);
    }
  }
`
